import React from 'react';

const SvgKn = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="KN_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="KN_svg__b" fill="#fff">
        <use xlinkHref="#KN_svg__a" />
      </mask>
      <use fill="#FFF" xlinkHref="#KN_svg__a" />
      <path fill="#1EC160" mask="url(#KN_svg__b)" d="M0 13.333L28 0H0z" />
      <path fill="#DF2A40" mask="url(#KN_svg__b)" d="M0 20h28V6.667z" />
      <path
        fill="#FFD956"
        mask="url(#KN_svg__b)"
        d="M.784 25.333l32.791-20.49-6.359-10.176-32.791 20.49z"
      />
      <path
        fill="#262626"
        mask="url(#KN_svg__b)"
        d="M-.63 23.072l32.792-20.49-3.533-5.654-32.791 20.49z"
      />
      <path
        fill="#FFF"
        mask="url(#KN_svg__b)"
        d="M20.31 7.797l-.946 1.498-.613-1.661-1.717-.437 1.39-1.097-.115-1.767 1.473.984 1.645-.656-.48 1.705 1.132 1.361zM9.643 14.264l-.946 1.497-.613-1.66-1.716-.437 1.39-1.097-.115-1.767 1.472.983 1.645-.655-.48 1.704 1.132 1.362z"
      />
    </g>
  </svg>
);

export default SvgKn;
